import { Title } from '@radix-ui/react-dialog'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

type TitleProps = ComponentPropsWithoutRef<typeof Title>

export interface SheetTitleProps extends TitleProps {
  asChild?: TitleProps['asChild']
}

export const SheetTitle = forwardRef<ElementRef<typeof Title>, SheetTitleProps>(
  ({ className, ...delegated }, ref) => (
    <Title
      ref={ref}
      className={cn('font-semibold text-lg', className)}
      {...delegated}
    />
  )
)
SheetTitle.displayName = Title.displayName
